export default __webpack_public_path__ + "static/media/Reports.BarChart.a97c251a.svg";